import { unwrapResult } from '@reduxjs/toolkit';
import React, { useEffect, useState } from 'react';
import { Col, Container, Row, Spinner } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import PageHeader from '../../components/PageHeader';
import { LoadingState } from '../../utilities/constants';
import EmissionForm from './EmissionForm';
import { fetchSingleEmissionData } from './emissionSlice';
import { updateEmissionApi } from './emissionApi';
import { toast } from 'react-toastify';
import { transErrorMessage } from '../../utilities/common';

const EditEmission = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();
  const { emissionId } = useParams();
  const { state: locationState } = useLocation();
  const [emission, setEmission] = useState(null);
  const [saveEmissionState, setSaveEmissionState] = useState(LoadingState.idle);
  const isBusy = saveEmissionState === LoadingState.loading;
  const orgId = useSelector((state) => state.users.user.usrOrgId);

  const handleEditEmission = async (data) => {
    try {
      setSaveEmissionState(LoadingState.loading);
      const requestData = { ...data, eDivId: emission.eDiv.divId, eEprflsrcId: emission.eEprflsrc.eprflsrcId };
      await updateEmissionApi(orgId, emissionId, requestData);
      setSaveEmissionState(LoadingState.succeeded);
      history.push(locationState?.returnTo || '/emissions/data');
    } catch(error) {
      setSaveEmissionState(LoadingState.idle);
      toast.error(transErrorMessage(t, error));
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const resultAction = await dispatch(fetchSingleEmissionData({ emissionId }));
        if (resultAction.payload) {
          const result = unwrapResult(resultAction);
          setEmission(result);
        }
      } catch (error) {}
    };
    fetchData();
  }, [dispatch, emissionId]);

  if (!emission) {
    return <Container fluid><Spinner animation="grow" /></Container>;
  }

  return (
    <Container fluid>
      <Row>
        <Col>
          <PageHeader
            title={t('Edit Emission')}
            enableBackButton
          />
          <EmissionForm
            onSubmit={handleEditEmission}
            initialValues={emission}
            EPName={emission.eEprflsrc?.eprflsrcName}
            entityName={emission.eDiv?.divName}
            emissionProfileSource={emission.eEprflsrc}
            buttonText={t('Save')}
            disabled={isBusy}
            isEdit={true}
            isDependentEmission={emission?.isDependentEmission}
          />
        </Col>
      </Row>
    </Container>
  );
};

export default EditEmission;
